import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const FiltersIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 18.5"
    >
      <g transform="translate(1 1)">
        <path
          d="M1299.716,7.135a1.884,1.884,0,1,1-1.885-1.885A1.885,1.885,0,0,1,1299.716,7.135Z"
          transform="translate(-1283.5 -5.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1290.863,13.5a1.885,1.885,0,1,1-1.885-1.885A1.885,1.885,0,0,1,1290.863,13.5Z"
          transform="translate(-1283.5 -5.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1295.474,19.865a1.885,1.885,0,1,1-1.885-1.885A1.885,1.885,0,0,1,1295.474,19.865Z"
          transform="translate(-1283.5 -5.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="3.604"
          transform="translate(16.216 1.885)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="12.447"
          transform="translate(0 1.885)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="12.458"
          transform="translate(7.363 8.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="3.594"
          transform="translate(0 8.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="7.667"
          transform="translate(12.333 14.615)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="8.026"
          transform="translate(0.179 14.615)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
